import { Stack } from "@fluentui/react";
import { useState } from "react";
import AIInsightsButtonWithPanel from "../../helper/AIInsightsButtonWithPanel";
import WarningBanner from "../../helper/WarningBanner";
import { CustomCardWithMetrics } from "../../SharedComponents/CustomCardWithMetrics";
import { ChartOption, MetricOptionProps } from "../../SharedComponents/Interfaces/CustomCardWithMetrics.interfaces";
import { CUSTOMER_VIEW_STYLES } from "../CustomerView/CustomerView.styles";

export default function FeatureChart(props: {
  readonly loading: boolean;
  readonly options: MetricOptionProps<any>;
  readonly onSelectedChartFilter: (filter: { filterKey: string; value: string }) => void;
  readonly tenantId: any;
  readonly tenantName: any;
  readonly bannerMessage?: string;
  readonly showAIInsights?: boolean;
}) {
  // Properties
  const [metricFilters, setMetricFilters] = useState<{ [key: string]: any }>({});
  const showAIInsights = props.showAIInsights ?? true;

  // Events
  const handleResetFilters = () => {
    setMetricFilters({});
    props.onSelectedChartFilter({
      filterKey: "",
      value: ""
    });
  };
  /**
   * onClick action for each datapoint in the chart
   */
  const handleDataPointClick = ({ field, title, value }: ChartOption) => {
    props.onSelectedChartFilter({
      filterKey: field,
      value: value
    });
    setMetricFilters((prev) => ({ ...prev, [title]: value }));
  };

  return (
    <>
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        styles={{ root: { justifyContent: "flex-end", paddingLeft: 8, paddingRight: 8 } }}
      >
        {!props.loading && props.options?.originalData?.length > 0 && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1 }}>
            <div style={{ flex: 1 }}>
              <WarningBanner
                message={
                  props.bannerMessage ??
                  "This view is limited to feature requests that are recorded in the CRM tool."
                }
              />
            </div>
            {showAIInsights && (
              <AIInsightsButtonWithPanel
                metricId="3"
                panelTitle="Feature Request Insights"
                tenantId={props.tenantId}
                tenantName={props.tenantName}
                buttonStyle={{ left: "auto" }}
              />
            )}
          </div>
        )}
      </Stack>
      <div className={CUSTOMER_VIEW_STYLES.COMMON_STYLES.CLASS_NAMES.customCardContainer}>
        <CustomCardWithMetrics
          enableUrlParams
          loading={props.loading}
          metricFilters={metricFilters}
          onDataPointClick={handleDataPointClick}
          onResetFilters={handleResetFilters}
          options={props.options}
        />
      </div>
    </>
  );
}
